export const REWARD_MODAL_STRINGS = {
  title: 'Congratulations!',
  subtitle: "You've received",
  error: 'Error: cannot find this reward in database',
  buttonGot: 'Got it!',
  buttonNext: 'Next badge',
  progress: 'You are on your way to the',
  checkBadges: 'Check your badges list for more badges!',
} as const;
